import React, { Component } from 'react';
import {FormControl} from "react-bootstrap";

export default class HoursFormControl extends Component {
    handleChange(event) {
        let value = event.target.value.replace(",", ".").replace(/[^\d.:]/g, "");
        let hasError = false;
        if (value.indexOf(":") !== -1) {
            const valueParts = value.split(":");
            if (!valueParts[1] || valueParts[1].length !== 2) hasError = true;
        } else if (value.split(".").length > 2) {
            hasError = true;
        }
        let minutes = HoursFormControl.parseHoursToMinutes(value);
        event.target.hasError = hasError;
        event.target.value = value;
        event.target.minutes = minutes;
        this.props.onChange(event);
    }

    static parseHoursToMinutes(stringValue) {
        stringValue = stringValue.replace(",", ".").replace(/[^\d.:]/g, "");
        let value = 0;
        if (stringValue.indexOf(":") !== -1) {
            const valueParts = stringValue.split(":");
            value = parseInt(valueParts[0], 10) * 60 + parseInt((valueParts[1] || 0), 10);
        } else {
            value = parseInt(parseFloat(stringValue.replace(",", ".")) * 60, 10);
        }
        return value;
    }

    static parseMinutesToHours(stringValue) {
        let hours = Math.floor(stringValue / 60);
        return hours + ":" + ("0" + (stringValue - hours * 60)).slice(-2);
    }

    render() {
        return <FormControl {...this.props}
                            // value={this.state.value}
                            componentClass="input"
                             placeholder="Hours"
                             onChange={this.handleChange.bind(this)} />
    }
}


// WEBPACK FOOTER //
// ./src/components/HoursFormControl.js